export const clean_logout = () => {
  localStorage.clear();
  sessionStorage.clear();
  return true;
}
